export class CredentialsProfile {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "CredentialsProfileAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "CredentialsProfileGcp",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return CredentialsProfile.attributeTypeMap;
    }
    constructor() {
    }
}
